import angular from 'angular';
import DefaultGrouping from './default';

class IssuesGrouping extends DefaultGrouping {
  constructor() {
    super();

    // this.currentCase = CurrentCase.data;
    this.displayName = 'Issues';
    this.key = 'legalIssues';
    this.ungroupedName = 'Organize Later';

    // null flags alphaSort to skip sorting this grouping
    this.groupingReverseSorted = null;

    this.columnsByGroup = super.setColumns([
      'factDateish',
      'title',
      'content',
      'sources',
      'tags',
      this.key,
      'contributors',
      'creationDate'
    ]);

    this.reverseSortable = true;
    this.sortDirectionText = {
      true: {
        text: 'Z - A',
        icon: 'glyphicon-sort-by-alphabet-alt'
      },
      false: {
        text: 'A - Z',
        icon: 'glyphicon-sort-by-alphabet'
      }
    };

  }

  getDisplayName(branch) {
    var issues = this.currentCase.legalIssues;
    return (issues && issues[branch.id]) ?
      issues[branch.id].displayName : this.ungroupedName;
  }

  getHeaderDisplayName(branch) {
    var issues = this.currentCase.legalIssues;

    var traverse = (branchId) => {
      var branch = issues && issues[branchId];
      return (branch && branch.parentId ? traverse(branch.parentId) : [])
        .concat(branch ? branch.displayName : this.ungroupedName);
    }

    return traverse(branch.id).join(' / ');
  }

  getFactItems(objs, branchId) {
    var items = [];
    for (var i = 0; i < objs.length; i++) {
      if (objs[i].id !== branchId) {
        items.push(objs[i].displayName);
      }
    }
    return items;
  }

  getDisplayText(tags, branchId) {
    return this.getFactItems(tags, branchId).join(',<br />');
  }

  getMemoText(tags, branchId) {
    return this.getFactItems(tags, branchId).join(', ');
  }

  getItemsByFact(fact) {
    var items = fact[this.key].map(function (item) {
      return item.id;
    });
    return items.length > 0 ? items : ['ungrouped'];
  }

  getDocDisplayText(value) {
    return this.getDisplayText(value);
  }

  getSortingValue(value) {
    return this.getMemoText(value);
  }
}
IssuesGrouping.$inject = [];

export default angular.module('groupings.issues-grouping', [])
  .service('IssuesGrouping', IssuesGrouping)
  .name;



// WEBPACK FOOTER //
// ./project/groupings/issues.js